import { useState } from "react";
import { faqs } from "../../../mocks/site";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-background-100/70 py-14 md:py-20">
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-700">
              <i className="ri-questionnaire-line" /> 常见问题
            </span>
            <h2 className="font-heading mt-2 text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
              关于吃瓜爆网，
              <br /> 你想了解的都在这里
            </h2>
            <p className="mt-4 text-foreground-600">
              关于内容来源、更新频率、投稿方式与版权原则等疑问，在这里都能找到答案。如果仍有困惑，欢迎通过底部联系方式随时与我们聊聊。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-customer-service-2-line" /> 联系内容团队
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-3">
            {faqs.map((f, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div
                  key={f.q}
                  data-open={isOpen}
                  className={
                    "faq-item overflow-hidden rounded-2xl border transition-colors " +
                    (isOpen
                      ? "border-primary-300 bg-background-50"
                      : "border-background-200 bg-background-50 hover:border-background-300")
                  }
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                    aria-expanded={isOpen}
                  >
                    <h3 className="flex items-start gap-3 text-base font-bold text-foreground-900 md:text-lg">
                      <span
                        className={
                          "mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs text-background-50 " +
                          (isOpen ? "bg-primary-500" : "bg-background-300")
                        }
                      >
                        {idx + 1}
                      </span>
                      <span>{f.q}</span>
                    </h3>
                    <span className="faq-icon flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500">
                      <i className="ri-add-line text-xl" />
                    </span>
                  </button>
                  <div className="faq-body px-5 md:px-6">
                    <p className="pb-5 pl-8 text-sm leading-relaxed text-foreground-600 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}